import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';
import { ICompanyUser } from 'types';

import { IExchangeSettings, IExchangeSettingsUser } from '../types/exchange-settings.type';

interface ExchangeSettingsInitialState extends BaseDataReducerInitialState<any> {
  settings: IExchangeSettings | null;
  isSaveInitiated: number | null;
  companyUsers: ICompanyUser[];
  availableSigners: IExchangeSettingsUser[];
}

const { initialState, AC, reducer } = basedDataReducer<any, ExchangeSettingsInitialState>('exchange-settings');

const exchangeSettingsInitialState: ExchangeSettingsInitialState = {
  ...initialState,
  settings: null,
  isSaveInitiated: 0,
  companyUsers: [],
  availableSigners: [],
};

export const exchangeSettings = createSlice({
  name: 'exchangeSettings',
  initialState: exchangeSettingsInitialState,
  reducers: {
    setExchangeSettings: (state, action: PayloadAction<IExchangeSettings | null>) => {
      state.settings = action.payload;
      const availableSigners = [];
      if (action.payload?.first_signatory_user) {
        availableSigners.push(action.payload?.first_signatory_user);
      }
      if (action.payload?.second_signatory_user) {
        availableSigners.push(action.payload?.second_signatory_user);
      }
      state.availableSigners = state.availableSigners.length > 0 ? state.availableSigners : availableSigners;
    },

    setIsSaveInitiated: (state, action: PayloadAction<number | null>) => {
      state.isSaveInitiated = action.payload;
    },

    setCompanyUsers: (state, action: PayloadAction<ICompanyUser[]>) => {
      state.companyUsers = action.payload;
    },

    setAvailableSigners: (state, action: PayloadAction<IExchangeSettingsUser[]>) => {
      state.availableSigners = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as ExchangeSettingsInitialState, action);
    });
  },
});
export const ExchangeSettingsAC = AC;

export const { setExchangeSettings, setIsSaveInitiated, setCompanyUsers, setAvailableSigners } =
  exchangeSettings.actions;
